// This file is part of Pollaris.
// Copyright 2024-2026 Marien Fressinaud
// Copyright 2026 Daniel Yepez Garces
// SPDX-License-Identifier: AGPL-3.0-or-later
//
// Modified by Daniel Yepez Garces on 2026-04-15:
// - Migrated database backend from PostgreSQL to MariaDB for Toolforge deployment
// - Added Wikimedia login support
// - Removed local username/password authentication
// - Added multilingual survey support
// - Added user timezone display for survey times when different from server UTC

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    print() {
        const previousColorScheme = document.documentElement.dataset.colorScheme;

        // Always print in "light" mode
        document.documentElement.dataset.colorScheme = 'light';
        print();
        document.documentElement.dataset.colorScheme = previousColorScheme;
    }
}
